import { Phone, Mail, MapPin, Instagram, Leaf, Clock } from "lucide-react";
import { COMPANY } from "./constants";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-forest-700 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Leaf className="w-8 h-8 text-forest-200" />
              <span className="font-serif text-2xl font-bold">{COMPANY.name}</span>
            </div>
            <p className="text-forest-200/80 mb-4">
              Professional landscape services for residential and commercial properties in Middle Georgia.
            </p>
            <div className="flex items-center gap-2 bg-forest-600/50 text-forest-100 px-3 py-2 rounded-lg inline-flex">
              <Clock className="w-4 h-4" />
              <span className="text-sm font-medium">24/7 Customer Support</span>
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg font-semibold mb-4 text-forest-100">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a href={COMPANY.phoneLink} data-testid="footer-phone-link" className="flex items-center gap-3 text-forest-200 hover:text-white transition-colors footer-link">
                  <Phone className="w-5 h-5" />
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-forest-200 hover:text-white transition-colors footer-link">
                  <Mail className="w-5 h-5" />
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a href={COMPANY.instagramLink} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-3 text-forest-200 hover:text-white transition-colors footer-link">
                  <Instagram className="w-5 h-5" />
                  {COMPANY.instagram}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg font-semibold mb-4 text-forest-100">Service Area</h4>
            <div className="flex items-start gap-3 text-forest-200">
              <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-white">{COMPANY.area}</p>
                <p className="text-sm mt-1">
                  Macon, Warner Robins, Perry, Byron, Forsyth, Gray, and surrounding areas
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-forest-600 mt-12 pt-8 text-center">
          <p className="text-forest-300 text-sm">
            &copy; {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
